module.exports = __webpack_public_path__ + "static/media/porductos_altena_pan.8a8ce76a.jpg";